import { render, staticRenderFns } from "./EnqueteDeliveryList.vue?vue&type=template&id=2fc0dffd&"
import script from "./EnqueteDeliveryList.vue?vue&type=script&lang=js&"
export * from "./EnqueteDeliveryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports